/**
 * @description type guard function that validates that the given redirectUrl is an allowed domain
 * Currently this should only be used for absolute URLs from the Alta
 * @returns boolean
 */
export const isValidAbsoluteRedirectUrl = (
  redirectUrl?: string,
): redirectUrl is string => {
  const re =
    /(http|https):\/\/*.*\.(alta.avigilon.com|avasecurity.com|ava.uk|openpath.com)/;
  const local = /(http):\/\/(localhost|127\.0\.0\.1):\d+/;

  if (!redirectUrl) return false;
  if (re.test(redirectUrl) || local.test(redirectUrl)) return true;

  // Allow OIDC authorize URLs on any host. Helium is the OIDC issuer for
  // internal tools and is reachable via several non-allow-listed hosts (e.g.
  // helium.{env}.openpath.com, api.{region}.alta.avigilon.com,
  // api.openpath.com). Rather than enumerate every issuer host, accept any
  // absolute URL whose path is /oauth/authorize -- Helium then enforces its
  // own redirect_uri allow-list against the inner redirect_uri parameter.
  try {
    const parsed = new URL(redirectUrl);
    if (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      parsed.pathname === '/oauth/authorize'
    ) {
      return true;
    }
  } catch {
    // Not a parseable absolute URL -- fall through to false.
  }

  return false;
};
